// import { Events } from "./events";
class Chat {
  static init() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    window.chatIsOpened = false
    dynamiclyInsertChatScript()
    setTimeout(Chat.additiannalInitiation, 5000)
    setTimeout(Chat.listenChatEvents, 5000)
  }

  static additiannalInitiation() {}

  static listenChatEvents() {
    setInterval(() => {
      if (window.chatIsOpened) {
        const isOpened = Chat.isOpened()
        if (!isOpened) Events.dispatchEvent('on_chat_closed')
      } else {
        const isOpened = Chat.isOpened()
        if (isOpened) Events.dispatchEvent('on_chat_opened')
      }
    }, 1000)

    // window.$chatwoot.on("widget:opened", function() {
    //   Events.dispatchEvent("on_chat_opened");
    //   window.chatIsOpened = true;
    // });
    // window.$chatwoot.on("widget:closed", function() {
    //   Events.dispatchEvent("on_chat_closed");
    //   window.chatIsOpened = false;
    // });
  }

  static setUserData(user, appData, userPreferences) {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    const config = {
      name: `${user.firstName} ${user.lastName}`,
      email: user.email,
      // phone: user.phoneNumber,
      // identifier: user.reference,
    }
    const customConfig = {
      Référence: user.reference,
      Prénom: user.firstName,
      Nom: user.lastName,
      'Id 1xBet': userPreferences?.xbetAccountId,
      'Id Betwinner': userPreferences?.betwinnerAccountId,
      Téléphone: user.phoneNumber,
      Email: user.email,
      Inscription: new Date(user.metaData?.registeredAt).getUTCDate(),
      "Bonuse d'affiliation": appData?.metaData?.affiliationBonusAmount,
      "Code d'affiliation": appData?.metaData?.affiliationCode,
      'Dépots de la journée': `${appData?.metaData?.vipAmountDone} FCFA`,
    }
    // window.$chatwoot.setUser(config.email, /* config */);
    window.$chatwoot.setUser(config.email, config)
    // window.$chatwoot.setConversationCustomAttributes(customConfig);
  }

  static openChat() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    window.$chatwoot.toggle('open')
  }

  static closeChat() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    window.$chatwoot.toggle('close')
  }

  static disconnectUser() {
    window.$chatwoot.reset()
  }

  static isOpened() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return false
    window.chatIsOpened = window.$chatwoot.isOpen
    return window.chatIsOpened
  }
}

function dynamiclyInsertChatScript() {
  const script = `
  (function(d,t) {
    var BASE_URL="https://app.chatwoot.com";
    var g=d.createElement(t),s=d.getElementsByTagName(t)[0];
    g.src=BASE_URL+"/packs/js/sdk.js";
    g.defer = true;
    g.async = true;
    s.parentNode.insertBefore(g,s);
    g.onload=function(){
      window.chatwootSDK.run({
        websiteToken: 'cZ7T6qQMGuvSbsHptpiW9NGQ',
        baseUrl: BASE_URL
      })
    }
  })(document,"script");
  `

  const scriptTag = document.createElement('script')
  scriptTag.setAttribute('type', 'text/javascript')
  scriptTag.innerHTML = script
  document.body.appendChild(scriptTag)
}

export { Chat }
